import { render, staticRenderFns } from "./JourneyDetails.vue?vue&type=template&id=6a023506&scoped=true&"
import script from "./JourneyDetails.vue?vue&type=script&lang=js&"
export * from "./JourneyDetails.vue?vue&type=script&lang=js&"
import style0 from "./JourneyDetails.vue?vue&type=style&index=0&id=6a023506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a023506",
  null
  
)

export default component.exports